import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLabviewComponent } from './simple-icons-labview.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLabviewComponent ],
    exports:      [ SimpleIconsLabviewComponent ],
    bootstrap:    []
})
export class SimpleIconsLabviewModule {}
